export default __webpack_public_path__ + "static/avatars-99b671cea12924716b2b492bd8b5ded3.png";